// Module
var code = "<div id=\"V-71C4296C-867D-46D6-B563-AAEC8FE7681A\"> <div data-b-component=\"grid\" data-b-comp-columnDefinition=\"auto 1fr\"> <h6 data-b-attach-column=\"1\" class=\"required\">صندوق : </h6> <div data-b-attach-column=\"2\" data-b-component=\"content\" data-b-comp-content=\"{Binding district}\"></div> </div> </div> ";
// Exports
export default code;